import * as Icons from "@nova/component-icons"
import { EventCategory, EventKind, eventTaxonomy } from "@nova/schemas"
import { EventIconBadge } from "features/events/EventTypeIcon"
import { LayerTypeIconSource, subjectIconSource } from "features/events/eventLabels"
import { ActivityEvent } from "./activityCopy"

const categoryIcons: Record<EventCategory, Icons.IconComponent> = {
    [EventCategory.Layers]: Icons.IconLayer,
    [EventCategory.Comments]: Icons.Chat,
    [EventCategory.Access]: Icons.People,
    [EventCategory.Pdfs]: Icons.PDFIcon,
    [EventCategory.PilotTracking]: Icons.Drone,
    [EventCategory.Atlas]: Icons.Share,
}

const systemBadges = {
    [EventKind.LayerProcessed]: "success",
    [EventKind.LayerProcessingFailed]: "failure",
    [EventKind.PdfFailed]: "failure",
} satisfies Partial<Record<EventKind, EventIconBadge>>

export type SystemEventKind = keyof typeof systemBadges

export const isSystemEvent = (
    event: ActivityEvent
): event is ActivityEvent & {
    kind: SystemEventKind
} => Object.hasOwn(systemBadges, event.kind)

export type ActivityIcon = { source: LayerTypeIconSource; badge: EventIconBadge }

export const activityIcon = (event: ActivityEvent & { kind: SystemEventKind }) => {
    const badge = systemBadges[event.kind]
    const source = subjectIconSource(event.subject_type)
    if (source) return { source, badge }

    const category = Object.hasOwn(eventTaxonomy, event.kind)
        ? eventTaxonomy[event.kind as EventKind].category
        : null

    return { source: category ? categoryIcons[category] : Icons.Processing, badge }
}
